export const getMessages = state => state.messages[state.messages.length - 1]



// WEBPACK FOOTER //
// ./client/store/modules/messages/getters.js